const MANUAL_BASE_PATH = '/manualusuario/'

const escapeForRegex = (value = '') => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Busca um bloco <export> específico dentro de um arquivo de manual em Markdown.
 * @param {Object} params
 * @param {string} params.file - Caminho relativo dentro de public/manualusuario (ex.: 'cadastro_produto_produto.md')
 * @param {string} params.exportId - Valor do atributo id no bloco <export>
 * @returns {Promise<string>} Conteúdo interno do bloco export (Markdown), ou string vazia se não encontrado
 */
export async function loadManualExportSnippet({ file, exportId }) {
    if (!file || !exportId) {
        return ''
    }

    const response = await fetch(`${MANUAL_BASE_PATH}${file}`)
    if (!response.ok) {
        console.error('Falha ao carregar arquivo do manual:', file, response.status)
        return ''
    }

    const content = await response.text()
    const regex = new RegExp(`<export\\s+id=[\"']${escapeForRegex(exportId)}[\"'][^>]*>([\\s\\S]*?)<\\/export>`, 'i')
    const match = content.match(regex)
    if (!match) {
        console.warn(`Bloco <export id=\"${exportId}\"> não encontrado em ${file}`)
        return ''
    }

    return match[1].trim()
}
